import { LoadingPanel } from '@gitbook/spine-react';

/**
 * Component to use a suspense fallback for a block.
 */
export function BlockLoadingFallback() {
    return (
        <div aria-busy className="rounded border">
            <LoadingPanel size="small" />
        </div>
    );
}
